import React, { useState, useEffect } from "react";
import "react-simple-keyboard/build/css/index.css";
import { isNull, map } from "lodash";
import ApiCms from "util/ApiCms";
import { useHistory, useRouteMatch } from "react-router-dom";
import { ApiKey, ApiUrl, WebUrl, SessionKey, LanguageOption } from "../../util/Constant";
import {
  showResponseMessage,
  setBusy,
  setIdle,
} from "../../redux/AppAction.js";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Header from "../../components/custom/Header";
import ApiEngine from "../../util/ApiEngine";

const HelpCentre = (props) => {
  const { t, i18n } = useTranslation();
  const { params } = useRouteMatch(WebUrl._URL_HELP_CENTRE_CATEGORY);
  const { category: Parent_Category } = params;

  const [categoryID, setCategoryID] = useState("");
  const [scrollTop, setScrollTop] = useState(0);
  const [isShowHelpCentreCategory, setIsShowHelpCentreCategory] =
    useState(false);
  const [breadcrumbs, updateBreadcrumbs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");
  const [parentCategories, setParentCategories] = useState([]);
  let _history = useHistory();
  var _dispatch = useDispatch();
  var _userData = useSelector(state => state.authState.userData);
  const [channels, setChannels] = useState([]);

  const onClick = (breadcrumbItems) => {
    updateBreadcrumbs((arr) => [...arr, breadcrumbItems]);
  };

  useEffect(() => {
    const scrollEvent = () => {
      window.addEventListener("scroll", (e) => {
        setScrollTop(e.target.documentElement.scrollTop);
      });
    };
    scrollEvent();

    return () => {
      // window.removeEventListener("scroll");
    };
  }, []);

  useEffect(() => {
    fetchData();
    init();
  }, []);

  async function fetchData() {
    _dispatch(setBusy());

    const { data } = await ApiCms.get(
      "/sub-categories" +
        "?locale=" +
        localStorage.getItem(SessionKey._LANGUAGE)
        +
        "&populate=*"
    );
    const { data: categoriesList } = data;

    setCategories(categoriesList);

    _dispatch(setIdle());
  }

  useEffect(() => {
    const fetchParent = async () => {
      const { data } = await ApiCms.get(
        "/categories" +
          "?locale=" +
          localStorage.getItem(SessionKey._LANGUAGE)
          +
          "&populate=*"
      );
      const { data: parentCategoriesList } = data;
      setParentCategories(parentCategoriesList);

      {
        parentCategoriesList.length &&
          parentCategoriesList.map((item, index) => {
            if (item.attributes.slug === Parent_Category)
              setCategoryID(item.attributes.category_id);
          });
      }
    };
    fetchParent();
  }, [(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
  localStorage.getItem(SessionKey._LANGUAGE) : 'en')]);

  useEffect(() => {
    setCategory(categoryID);
  }, [params]);

  async function init() {
    _dispatch(setBusy());
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_COMMUNICATION_CHANNELS + "?all=true&languageCode=" + 
      (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
      localStorage.getItem(SessionKey._LANGUAGE) : 'en')
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setChannelData(responseJson[ApiKey._API_DATA_KEY]);
    } 

    _dispatch(setIdle());
  }

  function setChannelData(data) {
    var channels = [];
    data.filter((i) => i.channelName.match(/Livechat/i)).map((d, index) => {
      var channel = {
        channelName: d.channelName,
        name: d.channelDescription,
        description: "",
        actionUrl: d.cta,
        image: d.channelImage,
        attachment: d.attachment,
      };

      channels.push(channel);
    });
    setChannels(channels);
  }

  async function GoToCategory(slug, category_id) {
    if (slug) {
      _history.push({
        pathname: WebUrl._URL_HELP_CENTRE_CATEGORY.replace(":category", slug),
        state: {
          category_id: category_id,
        },
      });
    }
  }

  async function GoToSubCategory(slug, sub_slug, category_id, sub_category_id) {
    if (slug) {
      _history.push({
        pathname: WebUrl._URL_HELP_CENTRE_SUB_CATEGORY
          .replace(":category", slug)
          .replace(":sub_category", sub_slug),
        state: {
          category_id: category_id,
          sub_category_id: sub_category_id,
        },
      });
    }
  }

  async function GoToFaq(
    slug,
    sub_slug,
    faq,
    category_id,
    sub_category_id,
    faq_id
  ) {
    if (sub_slug) {
      _history.push({
        pathname: WebUrl._URL_HELP_CENTRE_FAQ
          .replace(":category", slug)
          .replace(":sub_category", sub_slug)
          .replace(":faq", faq),
        state: {
          category_id: category_id,
          sub_category_id: sub_category_id,
          faq_id: faq_id,
        },
      });
    }
  }

  return (
    <>
      <Header
        history={_history}
        url={WebUrl._URL_HELP_CENTRE}
        title={t("HELP_CENTRE")}
      />
      <section className="help-centre-section">
        <div className="container" id="help-centre-banner">
          <div className="help-centre-sub-list-container row px-5 d-flex justify-content-start">
            <div className="help-centre-sub-list-wrapper d-flex justify-content-between">
              {category &&
                categories.length &&
                categories.map((item, index) => {
                  return (
                      !isNull(item.attributes.publishedAt) && ((!item.attributes.slug.includes("_")) || item.attributes.slug.match("_myr")) && 
                    item.attributes.category.data.attributes.category_id ===
                      category && (
                      <>
                        {/* <div className="help-centre-sub-list-flexbox help-centre-margin"> */}
                        <div
                          //  onClick={() => GoToSubCategory(item.attributes.category.data.attributes.title, item.attributes.Title)}
                          className="d-flex justify-content-between help-centre-first-list help-centre-margin help-centre-sub-list-flexbox"
                        >
                          <div>
                            <div className="help-centre-list-title font-semi" style={{ color: _userData.selectedTheme === 0 ? "#002e6c" : "white" }}>
                              {item.attributes.Title}
                            </div>
                            {item.attributes.faqs.data
                              .slice(0, 3)
                              .map((item1) => {
                                return (
                                    !isNull(item1.attributes.publishedAt) && ((!item1.attributes.slug.includes("_")) || item1.attributes.slug.match("_myr")) && (
                                    <div className="help-centre-list-item" style={{ color: _userData.selectedTheme === 0 ? "#002e6c" : "white" }}>
                                      <a
                                        onClick={() =>
                                          GoToFaq(
                                            item.attributes.category.data
                                              .attributes.slug,
                                            item.attributes.slug,
                                            item1.attributes.slug,
                                            item.attributes.category.data
                                              .attributes.category_id,
                                            item.attributes.sub_category_id,
                                            item1.attributes.faq_id
                                          )
                                        }
                                        className="list-link cursor-pointer"
                                      >
                                        {item1.attributes.Title}
                                      </a>
                                    </div>
                                  )
                                );
                              })}
                            <div>
                              <a
                                onClick={() =>
                                  GoToSubCategory(
                                    item.attributes.category.data.attributes
                                      .slug,
                                    item.attributes.slug,
                                    item.attributes.category_id,
                                    item.attributes.sub_category_id
                                  )
                                }
                                className="text-gold font-11 cursor-pointer"
                              >
                                {t("SEE_ALL")}
                              </a>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </>
                    )
                  );
                })}
            </div>
          </div>
        </div>
        <div className="helpcentre-contact container">
          <div className="help-centre-other-ways-container" style={{ color: _userData.selectedTheme === 0 ? "#002e6c" : "white" }}>
            {t("STILL_NEED_HELP")}
          </div>
          <div className="help-centre-other-ways-list-container d-flex justify-content-around">
            {channels.map((channel, index) => {
              return (
                <div key={index} className="help-button" style={{ color: _userData.selectedTheme === 0 ? "#002e6c" : "white" }}
                  onClick={() => { 
                      window.open(channel.actionUrl, "_blank", 'live-chat')
                  }}
                >
                  <div className="d-flex justify-content-between help-centre-other-ways-list">
                    <div>
                      <div
                        className="help-centre-other-ways-title"
                        // onClick={() =>
                        //   _history.push({
                        //     pathname: WebUrl._URL_CONTACT_US,
                        //   })
                        // }
                      >
                        {t("LIVE_CHAT")}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}

            <div className="help-button" style={{ color: _userData.selectedTheme === 0 ? "#002e6c" : "white" }}>
              <div
                className="d-flex justify-content-between help-centre-other-ways-list"
                onClick={() =>
                  _history.push({
                    pathname: WebUrl._URL_CONTACT_US,
                  })
                }
              >
                <div>
                  <div className="help-centre-other-ways-title">
                    {t("CONTACT")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default HelpCentre;
